import React from 'react';

import { DailyActivity } from '@vyce/core/src/views/time/ActivityLogs/DailyActivity';

import { useTypedSelector } from '../../hooks';

export const EmployerDailyActivity: React.FC = () => {
  const { selectedCompany } = useTypedSelector(state => state.helper);

  // canViewLocation is no longer computed here — DailyActivity reads the
  // permission context itself, so it can scope per location.
  return <DailyActivity companyId={selectedCompany?.uuid} />;
};
